import { FieldLocaleType, LanguagesType } from "../app";
import { ITeamSetting } from "@/interfaces/teams/teams";
import { ITimeSlot } from "./timeslots";
import { ICreateAddons } from "./product-slot-state";

export const TYPE_NORMAL = 1; // we may use inheritance for those type
export const TYPE_GIFT_CARD = 2; // only takes voucher resource
export const TYPE_SEATED_SUB = 31;
export const TYPE_SEATED = 3;
export const TYPE_PLUGIN = 4;
export const TYPE_GOOGLE = 5;
export const TYPE_MERCHANDISING = 6;
export const TYPE_EVENT_PASS = 7; // Link event to this pass
export const TYPE_EVENT = 8;
export const TYPE_SEATED_PASS = 9; //behave like 3, is linked to all 3, event key is the sum of it's resource and all underlying resources.
export const TYPE_ADD_ON = 10;
export const TYPE_DONATION = 11;
export const TYPE_BUNDLE = 12;
export const TYPE_LIGHT_QUANTITY = 13; //Not a category type, only a PSS.type
export const TYPE_MEMBERSHIP = 14;
export const TYPE_OVV = 15; //Used to have a simplified version of recurring tickets.
export const TYPE_MEMBERSHIP_VOUCHER = 16;
export const TYPE_MEMBERSHIP_SEATED = 17;
export const TYPE_RECURRING = 18;
export const TYPE_PRODUCT_SLOT = 19; // NOT USED It is to save the logic for the old normal until we remove it.

// Used for selling products without stock if the PC have this field
export const PC_SELL_ON_SOLD_OUT = 1;

export enum PCTypes {
  Normal = 1, // we may use inheritance for those type
  GiftCard = 2, // only takes voucher resource
  SeatedSub = 31,
  Seated = 3,
  Plugin = 4,
  Google = 5,
  Merchandising = 6,
  EventPass = 7, // Link event to this pass
  Event = 8,
  SeatedPass = 9, //behave like 3, is linked to all 3, event key is the sum of it's resource and all underlying resources.
  AddOn = 10,
  Donation = 11,
  Bundle = 12,
  LightQuantity = 13, //Not a category type, only a PSS.type
  Membership = 14,
  OVV = 15, //Used to have a simplified version of recurring tickets.
  MembershipVoucher = 16,
  MembershipSeated = 17,
  Recurring = 18,
  ProductSlot = 19,
  Retail = 20,
}

export interface IProductSlotPrice {
  id: number;
  uuid: string;
  name: string;
  nameLocale: Partial<FieldLocaleType>;
  description: string;
  descriptionLocale: Partial<FieldLocaleType>;
  value: number;
  priceOnsite: number | null;
  quantity: number;
  totalQuantity: number;
  cancelled?: number;
  isEditable?: number;
  sortPrice?: number;
  vatRateGeneralId: number;
  taxes: ITax[];
  retail: IRetailOption[];
  updatedAt: string;
  addons: IPackagePrice[];
  availability: number | null;
  priceCategory?: number;
  packageMinQuantity?: number | null;
  packageMaxQuantity?: number | null;
  minBooking?: number | null;
  maxBooking?: number | null;
}

export interface IPackagePrice {
  id: number;
  priceId: number;
  priceUuid: string;
  automaticallyBook: number;
  canceled: number;
  isMandatory: number;
  priority: number;
  sendTicket: number;
  displayedValue: number | null;
  accountingValue: number;
  minutesBefore: number;
  minutesAfter: number;
  minutesBeforeStartMin: number;
  minutesBeforeStartMax: number;
  minutesAfterStartMin: number;
  minutesAfterStartMax: number;
  maxQuantity: number;
  minQuantity: number;
  displayPage: number;
  isUseAddonDateTime?: number | null;
}

export interface IRetailOption {
  id: number;
  uuid: string;
  name: string;
  nameLocale: Partial<FieldLocaleType> | null;
  inventoryAlert: number;
  type: number;
  barcode: string;
  sku: string;
  smeetzPictures: ISmeetzPicture[];
  sellingSoldOut: number;
  deletedAt: string | null;
  optionSort: number;
}

export interface ITax {
  id: number | null | undefined;
  name: string | null | undefined;
  taxNumber?: string;
  rate: number | null | undefined;
  rateMiliValue?: number | null;
  includedInPrice: number | null | undefined;
  deletedAt?: string | null;
  // FIS-712: set on the taxes of a price on a tax scheme (2+ taxes, from the services catalog)
  position?: number;
  baseMode?: number;
}

export enum TaxType {
  IncludedTax = 0,
  ExcludedTax = 1,
}

export enum RetailOptionType {
  Default_Retail_Option = 100,
}

export const RetailOptionTypes = RetailOptionType;

export interface ISmeetzPicture {
  id: number;
  name: string;
  metaData: string;
  entity: string;
  entityId: number;
}

export interface IHandshakeCategoryTspropertyList {
  areaName: string;
  areaCode: string;
  ticketTypeName: string;
  ticketTypeCode: string;
}

export interface IPCPromoCodeCampaignList {
  id: number;
  giftCardTicketId: number;
  startDateTime: string;
  endDateTime: string;
  expiryType: number;
  expiryDays: number;
  cancelled: number;
}
export interface ICategoryInfo {
  scanOpeningMinutesBeforeStart: number;
}
export interface IProductCategory {
  _id?: string;
  id: number;
  uuid: string;
  name: string;
  seatsCat?: string | null;
  nameLocale: Partial<FieldLocaleType>;
  description: string;
  descriptionLocale: Partial<FieldLocaleType>;
  ticketGroups: number[];
  type: string;
  address?: string | null;
  qrCodeType?: number | null;
  stockIds?: number[];
  // stock units one ticket consumes, per linked stock (stock_category.quantity)
  stockConsumptions?: { [stockId: number]: number };
  memberships: IPCMembership[];
  product: {
    id: number;
    uuid: string;
    isIdivTax?: number;
    name: string;
    nameLocale: Partial<FieldLocaleType>;
    currency: string;
    pictureUrl: string;
    status?: number | null;
    customTicketFields?: ICustomField[];
    customBookingFields?: ICustomField[];
    productBrandings?: IProductBranding[];
  };
  prices: IProductSlotPrice[];
  multipleScan?: number | null;
  teamSetting?: ITeamSetting | null;
  saleStartType: number | null | undefined;
  saleStart: string | null | undefined;
  saleEndType: number | null | undefined;
  saleEnd: string | null | undefined;
  salesEndDurationMinutes: number | null | undefined;
  salesStartDurationDays: number | null | undefined;
  timeSlotCount?: number | null;
  isRecurring?: boolean;

  // Seating Plan fields
  seatingParentPSCId: null | number;
  isParentReccuringSeating: null | number;
  seatingParentResourceEventKey: null | string;
  seatingParentCategoryName: null | string;
  // assigned a value when the PC is a parent and type not reccuringSeating plan
  resourceEventKey?: null | string;
  // assigned a value when the PC is a parent
  subCategories?: IProductCategory[];
  isReccuringSeating?: null | number;
  resource?: { quantity: number } | null; // this will hold the value of availabilities in case of none-reccuring seating plan

  // skidata handshake config
  handshakeCategoryTsproperty?: IHandshakeCategoryTspropertyList | null;
  promoCodeCampaignList?: IPCPromoCodeCampaignList[];
  categoryInfo?: ICategoryInfo | null;

  // Barcodes array for Dexie indexing (extracted from prices[].retail[].barcode)
  barcodes?: string[];

  // SKUs array for Dexie indexing (extracted from prices[].retail[].sku)
  skus?: string[];

  // Price IDs array for Dexie indexing (extracted from prices[].id)
  priceIds?: number[];
}

export interface IPCMembership {
  id: number;
  startDate: string;
  expiryDate: string;
  type: number;
  expiryType: number;
  periodLength: number;
  numberMandatoryPeriod: number;
}

export interface IProductCard extends IProductCategory {
  availability?: number;
  startDateTime?: string;
  endDateTime?: string;
  isAvailable?: boolean;
}

export interface IProductTableData extends IProductCategory {
  productCategoryId: IProductCategory["id"];
  dbAvailability?: number;
  startDateTime?: string;
  endDateTime?: string;
  timeslot_ID?: string;
  timeslots?: ITimeSlot[];
}

export interface ICardData {
  productCategoryId?: number;
  productName?: string;
  categoryName?: string;
  dbAvailability?: number;
  startDateTime?: string;
  endDateTime?: string;
  currency?: string;
  pictureUrl?: string;
  price?: number;
  prices?: IProductSlotPrice[];
  timeslot_ID?: string; // _id
  productCategory_ID?: string; // _id
  type: string;

  saleStartType?: number | null | undefined;
  saleStart?: string | null | undefined;
  saleEndType?: number | null | undefined;
  saleEnd?: string | null | undefined;
  salesEndDurationMinutes?: number | null | undefined;
  salesStartDurationDays?: number | null | undefined;

  stockIds: number[];
  stockConsumptions?: { [stockId: number]: number };
  booked?: number;

  // Seating Plan fields:
  eventKey: string | null;
  isReccuringSeating: number | null;
  seatingParentPSCId: number | null;
  seatingParentCategoryName: string | null;
  seatedSubs?: IProductCategory[];
}

export interface ICustomField {
  id: string;
  productId: number;
  name: string;
  answerExample: string;
  position: number;
  cancelled: number;
  questionType: number;
  informationType: number;
  list: string[];
  validation: number;
  visibleFor: number;
  prices?: number[];
  customFieldType?: CustomFieldType; // Whether it is TICKET custom fields or BOOKING custom fields
}

export interface IProductBranding {
  id: number;
  customText?: string;
  description1?: string;
  description2?: string;
  description3?: string;
}

export enum CustomFieldType {
  BOOKING = 1,
  TICKET = 2,
}

export enum CustomFieldVisibility {
  ONLINE = 1,
  INTERNAL = 2, // This type is shown for POS
  ONLINE_INTERNAL = 3,
  RESELLER = 4,
  RESELLER_INTERNAL = 6,
  ALL = 7, // This type is shown for POS
}

export enum CustomFieldValidation {
  OPTIONAL = 0,
  MANDATORY = 1,
}

export enum QuestionType {
  TEXT = 1, // Text
  DROPDOWN = 2, // Dropdown box'
  LIST = 3, // List box
  FILE = 4, // File
  RADIO = 5, // Radio button
  DATE = 6, // Date
  LONG_TEXT = 7, //Long text
  CHECKBOX = 8, //Checkbox
}

export enum InformationType {
  OTHER = 1, // Other
  PHONE = 2, // Phone
  COMPANY = 3, // Company name
  TAX = 4, // Tax number
  FIRSTNAME = 5, // First name
  LASTNAME = 6, // Last name
  EMAIL = 7, // Email
  ADDRESS = 8, // Address
  CITY = 9, // City
  ZIP = 10, // Zip
  COUNTRY = 11, // Country
  LANGUAGE = 26, // Language
  PASSPORT = 13, // Passport
  MARKETING = 14, // Marketing
  PICTURE = 15, // Picture
  GOOGLE_PLACE_ID = 16, // Google Place ID
  BIRTH_DATE = 17, // Birth date
  CFF_REDUCTION = 18, // CFF reduction
  MEMBERSHIP_DISCOUNT = 19, // Membership discount
  MEMBERSHIP_DISCOUNT_CUSTOMER = 20, // Membership customer
  WEIGHT = 21, // Weight
  GENDER = 22, // Gender
  TITLE = 23, // Title
  HOUSE_NUMBER = 24, // House Number
}

export interface ICustomFieldAnswer {
  id?: number; // Used only by backend in PUT synchronize-bookings
  uuid: string;
  bookingUuid?: string; // For answers linked to a booking
  pssUuids?: string[]; // For answers linked to a booking, needed when pss are removed and we need to remove custom fields from the booking
  pssUuid?: string; // For answers linked to a pss
  answer: string;
  fileID?: string;
  fileUrl?: string;
  isInvalid?: boolean;
  validationMessage?: string;
  isCropped?: boolean;
  listAnswer: string[] | string;
  createdAt: string;
  updatedAt: string;
  customField: ICustomField;
  priceId?: string;
  priceName?: string;
  categoryId?: string;
  categoryName?: string;
  customFieldAnswerId?: string;
}

export enum ProductStatus {
  DRAFT = 0,
  LIVE = 1,
  CANCELED = 2, // Archived product
  DELETED = 5, // Deleted product
}

export enum SalesStartType {
  SALE_START_TYPE_NOW = 1, // Sales start now
  SALE_START_TYPE_DATE = 2, // Sales start on an exact date
  SALE_START_TYPE_OFFSET = 3, // Sales start X days before activity starts (X is the value of saleStartDurationDays)
}

export enum SalesEndType {
  SALE_END_TYPE_END = 1, // Sales end at the end of the activity
  SALE_END_TYPE_DATE = 2, // Sales end on an exact date
  SALE_END_TYPE_OFFSET = 3, // Sales end X minutes before/after activity (X is the value of saleEndDurationMinutes)
  // (if positive value for the field saleEndDurationMinutes then we consider BEFORE / if negative value for the field saleEndDurationMinutes then we consider AFTER)
  SALE_END_TYPE_START = 4, // Sales end at the beginning of the activity
}

export const MEMBERSHIP_TICKETS = [
  PCTypes.EventPass,
  PCTypes.SeatedPass,
  PCTypes.Membership,
  PCTypes.MembershipVoucher,
  PCTypes.MembershipSeated,
];

// Parent product category types that drive the seats.io seating chart UX.
// Both regular seating plans (type 3) and membership seating plans (type 17)
// expose sub-categories, a resourceEventKey and trigger the seating modal.
export const SEATING_PARENT_TYPES: PCTypes[] = [
  PCTypes.Seated,
  PCTypes.MembershipSeated,
];

// PC.type is sometimes stored as a number (Dexie / GraphQL response) and
// sometimes as a string (ICardData / converted card data). Accept both.
export function isSeatingParentType(
  type: number | string | null | undefined
): boolean {
  if (type === null || type === undefined) return false;
  return SEATING_PARENT_TYPES.some((t) => type === t || type === PCTypes[t]);
}

export interface IAddToBasketData {
  pssQuantity: number; // quantity selected
  isRetail: boolean;
  nonAutomaticAddons?: ICreateAddons[]; // list of non automatic addons
  price?: IProductSlotPrice; // selected price if any; falls back to productCategory.prices[0]
  productCategory: IProductCategory; // product category
  timeslot?: ITimeSlot; // slot of the tapped card; tickets must carry it, retail has none
  seatId?: string; // only used for seating plan, note that in seating plan we create one pss at a time (GA doesn't consider a seatId)
  eventKey?: string; // only sor seating plan
  seatType?: SeatType; // only for seating plan
  overridePrice?: number; // manual price override for the parent line (major units, e.g. 8.99)
  parentSeatingType?: PCTypes; // type of the seating-plan parent PC (Seated=3 vs MembershipSeated=17), drives pss.type for membership seating plan
}

/**
 * Defines price category (Adult, Child, Reduced, Others)
 */
export enum PriceCategory {
  Adult = 1,
  Reduced,
  Child,
  Other,
}

/**
 * Defines seating type (Seat or GeneralAdmissionArea)
 */
export enum SeatType {
  Seat = "Seat",
  GeneralAdmissionArea = "GeneralAdmissionArea",
}
